<template>
  <div class="container">
    声音功能全新升级，音频面板即将下线，请到右上角<b>“声音与字幕”</b>处进行配音、配乐添加和设置。
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  created () {
    // let list = this.$store.getters['smartVoice/newSoundMsgs'];
    // list = [...list, this];
    // this.$store.commit('smartVoice/setNewSoundMsgs', list);
  },
  beforeDestroy () {
    // let list = this.$store.getters['smartVoice/newSoundMsgs'];
    // list = list.filter(v => {
    //   return v != this
    // });
    // this.$store.commit('smartVoice/setNewSoundMsgs', list);
    this.io && this.io.disconnect();
  },
  mounted () {
    this.io = new IntersectionObserver((list) => {
      let data = list[0];
      let flag = data.isIntersecting;
      if (flag) {
        this.$bus.emit('showNewSoundMsg', flag);
      }
    });
    this.io.observe(this.$el);
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.container {
  min-width: 270px;
  height: 70px;
  background: #fff2e8;
  line-height: 20px;
  color: #9d6740;
  font-size: 12px;
  padding: 7px 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/rightnav/newSoundFeature.vue